import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import { DatePipe,  } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { Router } from '@angular/router';

import 'rxjs/add/observable/of';

import { LiquidacionService } from 'app/services/liquidacion/liquidacion.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;
@Component({
  selector: 'app-listado-resumen',
  templateUrl: './listado-resumen.component.html',
  styleUrls: ['./listado-resumen.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,
    DatePipe,
  
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoResumenComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;

  user: any = [];
  loading: boolean = false;
  abrirPopUp: boolean = false;

  dataSource: any = [];
  resumenLiquidaciones: any = [];

  proveedoresArr: any = [];
  adquirentesArr: any = [];
  form: FormGroup;

  filteredProveedores: Observable<any[]>;
  filteredAdquirentes: Observable<any[]>;

  filterForm =  new FormGroup({
    provFilter: new FormControl(''),
    adqFilter: new FormControl(''),
    idProvFilter: new FormControl(''),
    idAdqFilter: new FormControl(''),
    monedaFilter: new FormControl({value: 0,disabled: false}),
    estadoFilter: new FormControl({value: "",disabled: false}),
    fromDate: new FormControl({value: '',disabled: true}),
    toDate: new FormControl({value: '',disabled: true})
  });

  


  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns = ['checked','idResumen_Liquidaciones','Proveedor','Adquirente','Fecha','Moneda','Interes_Proveedor','Deuda_Importe','Interes_Liquidacion_Proveedor','Interes_Liquidacion_Adquirente','Estado'];
  

  constructor(private datePipe:DatePipe,private router:Router,private liquidacionService:LiquidacionService) {
    //Falta los guards!!
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
   }

  ngOnInit() {
    this.obtenerProveedoresCombo(); 
    this.obtenerAdquirentesCombo();    
    this.obtenerListaResumenLiquidacion();
  }

  obtenerListaResumenLiquidacion(){
    console.log("filterForm",this.filterForm.getRawValue());

    this.loading = true;

    let desde: string = this.datePipe.transform(this.filterForm.get('fromDate').value,'yyyy-MM-dd');
    let hasta: string = this.datePipe.transform(this.filterForm.get('toDate').value,'yyyy-MM-dd');

    desde = (desde == null ? "" : desde);
    hasta = (hasta == null ? "" : hasta);

    this.filterForm.get('fromDate').setValue(desde);
    this.filterForm.get('toDate').setValue(hasta);

    this.liquidacionService.obtenerResumenLiquidaciones(this.filterForm.getRawValue()).subscribe(
      res =>{
          this.resumenLiquidaciones = res;
          this.dataSource = new MatTableDataSource(this.resumenLiquidaciones);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.loading = false;
      },err =>{
          Swal.fire({
              title: "¡Algo salió mal!",
              text:  err.error['error'],
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false 
          });
          this.loading = false;
      }
    )
  }



  setMoneda(event){
    this.filterForm.controls['monedaFilter'].setValue((event == "" ? 0 : event));
  }

  obtenerProvId(provId :string){
    this.filterForm.get('idProvFilter').setValue(provId);
  }

  obtenerpdf($file:any){
    window.open($file,"_blank");
  }

  obtenerAdqId(adqId :string){
    this.filterForm.get('idAdqFilter').setValue(adqId);
  }

  obtenerRucRazSocialProv(termino: string = ''){
    if (termino != null && termino != ''){
      termino = termino.toLowerCase();                  
      for(let p of this.proveedoresArr){
        let raz = p.Razon_Social.toLocaleLowerCase();
        let ruc = p.Num_Doc_Identificacion;
        if (raz.indexOf(termino) >= 0 || ruc.indexOf(termino) >= 0){
          this.filterForm.get('idProvFilter').setValue(p.idEmpresa);
          this.filterForm.get('provFilter').setValue(p.Razon_Social);
          break;
        }
      }
    } else {
      this.filterForm.get('idProvFilter').setValue('');
      this.filterForm.get('provFilter').setValue('');
    }
  }

  obtenerRucRazSocialAdq(termino: string = ''){
    if (termino != null && termino != ''){          
      termino = termino.toLowerCase();                
      for(let p of this.adquirentesArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
          let ruc = p.Num_Doc_Identificacion;
        if (raz.indexOf(termino) >= 0 || ruc.indexOf(termino) >= 0){
          this.filterForm.get('idAdqFilter').setValue(p.idEmpresa);
          this.filterForm.get('adqFilter').setValue(p.Razon_Social);
          break;
        }
      }
    } else {
      this.filterForm.get('idAdqFilter').setValue('');
      this.filterForm.get('adqFilter').setValue('');
    }
  }

  obtenerProveedoresCombo(){
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveedores = this.filterForm.get('provFilter').valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterProv(state) : this.proveedoresArr.slice())
    );   
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
      state.Num_Doc_Identificacion.includes(filterValue) === true
    );
  }

  obtenerAdquirentesCombo(){
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.filterForm.get('adqFilter').valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterAdq(state) : this.adquirentesArr.slice())
    );  
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.adquirentesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
      state.Num_Doc_Identificacion.includes(filterValue) === true
    );
  }

  AbrirPoPup(element){
    this.liquidacionService.proveedorCorreo = element
    this.abrirPopUp = true;
  }
  CerrarPopUp(){
    this.abrirPopUp = false;
  }

  ConfirmarResumen(idResumen_Liquidaciones) {
    Swal.fire({
      title: '',
      text: '¿Estás seguro de confirmar el resumen '+ idResumen_Liquidaciones +'?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, Aceptar.',
      cancelButtonText: 'No, Cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      console.log('nais');
      if (result.value) {
        Swal.fire({
          title: '¡Espere!',
          html: 'Procesando solicitud.',
          heightAuto: false
        });
        Swal.showLoading();
        this.form = new FormGroup({
          'idResumen_Liquidaciones': new FormControl(idResumen_Liquidaciones),
          'canal': new FormControl('W'),
          'usuario': new FormControl(this.user.Usuario)
        });
        this.liquidacionService.confirmarResumen(this.form.getRawValue()).subscribe(
          res => {
            Swal.fire({
              title: '¡Éxito!',
              text: 'Resumen de liquidación Confirmada.',
              type: 'success',
              heightAuto: false
            }).then(resp => {
              if (resp.value == true) {
                this.obtenerListaResumenLiquidacion();
              }
            });
          },
          err => {
            Swal.fire({
              title: "Error",
              text: "No se pudo confirmar el resumen.",
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          });
      }
    });
  }

  bajaResumen(idResumen_Liquidaciones) {
    Swal.fire({
      title: 'Atención',
      text: '¿Estás seguro de dar de baja el resumen '+ idResumen_Liquidaciones +'?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si,dar de baja.',
      cancelButtonText: 'No,Cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: '¡Espere!',
          html: 'Procesando solicitud.',
          heightAuto: false
        });
        Swal.showLoading();        
        this.liquidacionService.bajaResumen(idResumen_Liquidaciones, 'W', this.user.Usuario).subscribe(
          res => {
            this.obtenerListaResumenLiquidacion();
            Swal.fire({
              title: 'Éxito!',
              text: 'El Resumen se ha dado de baja exitosamente.',
              type: 'success',
              heightAuto: false
            });
          },
          err => {
            Swal.fire({
              title: "Error",
              text: "No se pudo dar de baja el Resumen.",
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          })
      }
    });
  }

}
